import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
  fetchChargingTokens: ['offset', 'shouldShowError'],
  fetchChargingTokensLoading: null,
  fetchChargingTokensSuccess: [
    'offset',
    'chargingTokens',
    'nextOffset',
    'filterObject',
  ],
  fetchChargingTokensError: ['error'],

  editChargingToken: ['chargingTokenId', 'updatedValues'],
  editChargingTokenLoading: null,
  editChargingTokenSuccess: ['chargingToken'],
  editChargingTokenError: ['error'],

  deleteChargingToken: ['chargingTokenId'],
  deleteChargingTokenLoading: null,
  deleteChargingTokenSuccess: ['chargingTokenId'],
  deleteChargingTokenError: ['error'],

  createChargingToken: ['values'],
  createChargingTokenLoading: null,
  createChargingTokenSuccess: ['chargingToken'],
  createChargingTokenError: ['error'],

  createChargingTokenBulk: ['chargingToken'],
  createChargingTokenBulkLoading: null,
  createChargingTokenBulkSuccess: ['chargingTokens'],
  createChargingTokenBulkError: ['error'],

  downloadChargingTokenSampleFile: null,
  downloadChargingTokenSampleFileLoading: null,
  downloadChargingTokenSampleFileSuccess: null,
  downloadChargingTokenSampleFileError: ['error'],

  getChargingTokensCount: null,
  getChargingTokensCountLoading: null,
  getChargingTokensCountSuccess: ['count'],
  getChargingTokensCountError: ['error'],

  clearChargingTokens: null,
  setDeleteChargingTokenRequestState: ['newState'],
})

export const ChargingTokenTypes = Types
export default Creators
